import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminAgentContent } from '@apps/web/routes/_app/admin/agent/admin_agent_content';

const adminAgentSearchSchema = z.object({
    chat_id: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/admin/agent/')({
    component: AdminAgentIndexPage,
    validateSearch: adminAgentSearchSchema,
});

function AdminAgentIndexPage() {
    const { chat_id: chatId } = Route.useSearch();
    return <AdminAgentContent initialRunId={null} initialChatId={chatId} />;
}
